
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/selling/detailed-expert-report",
      function () {
        return require("private-next-pages/content/selling/detailed-expert-report.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/selling/detailed-expert-report"])
      });
    }
  